'use strict';

import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import MediaUploaderSmall from '../react-components/MediaUploader/MediaUploaderSmall.jsx';

function setLogotypeUploader(element) {
    var convertType = function (value){
        var v = Number (value);
        return !isNaN(v) ? v :
             value === "undefined" ? undefined
           : value === "null" ? null
           : value === "true" ? true
           : value === "false" ? false
           : value
     };

    const path = convertType(element.getAttribute('data-path'));
    const cropPath = convertType(element.getAttribute('data-crop-path'));
    const filter = convertType(element.getAttribute('data-filter'));
    const ref = convertType(element.getAttribute('data-ref'));
    const userId = convertType(element.getAttribute('data-id'));

    ReactDOM.render(
        <MediaUploaderSmall path={path}
                            filter={filter}
                            reference={ref}
                            userId={userId}
                            cropPath={cropPath}
        />
    , element)
}

function init() {
    const $element = $('.js-logo-react');
    if ($element) {
        $element.each((index, domElement)=>{
            setLogotypeUploader(domElement);
        })
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/logotype-upload/logotype-upload.js